import { Typography } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";
import React from "react";
import { useRecordContext } from "react-admin";

interface ICustomDateField {
  source: string;
  isDateTime?: boolean;
  label?: string;
  emptyText?: string;
}

const CustomDateField = ({ source, isDateTime }: ICustomDateField) => {
  const resource = useRecordContext();
  const format = isDateTime ? "DD / MM / YYYY, hh:mm A" : "DD / MM / YYYY";

  const date = get(resource, source);

  return (
    <Typography variant="body2">
      {date === undefined || date === null
        ? `-`
        : moment.utc(date).format(format)}
    </Typography>
  );
};

export default CustomDateField;
